import { Column } from "@/constants/pipeline";
import { ValCallModel } from "@/models/pipeline";
import moment from "moment";
import { ApplicationDropdown } from "./ApplicationDropdown";
import { FirstColumnContent } from "./FirstColumnContent";
import { Row } from "./Row";
import { RowContent } from "./RowContent";
import { ValCallStatus } from "./ValCallStatus";

type ValCallRowProps = {
  data: ValCallModel;
  agentId: number;
  columns: Column[];
  isPinned: boolean;
  onTogglePin: (id: string) => void;
  isDepartmentView?: boolean;
};

export const ValCallRow = ({
  data,
  agentId,
  columns,
  isPinned,
  onTogglePin,
  isDepartmentView = false,
}: ValCallRowProps) => {
  const paidOutDateFormatted = data.paidOutDate ? moment(data.paidOutDate).format("DD MMM") : "";

  return (
    <Row id={data.applicationId!} data={data} step="valCall">
      <RowContent
        columns={columns}
        children={[
          <FirstColumnContent
            itemId={data.applicationId.toString()}
            agentId={agentId}
            isPinned={isPinned}
            handoverAllocatedUserId={data.handoverAllocatedUserId}
            handoverToUserId={data.handoverToUserId}
            customerName={data.customerName}
            onTogglePin={onTogglePin}
            isDepartmentView={isDepartmentView}
          />,
          <span className="truncate">{data.applicationId}</span>,
          <span className="truncate">{paidOutDateFormatted}</span>,
          <ValCallStatus status={data.dealerValCallResult} />,
          <ValCallStatus status={data.customerValCall1Result} />,
          <ValCallStatus status={data.customerValCall2Result} />,
          <ApplicationDropdown
            applicationId={data.applicationId.toString()}
            isPinned={isPinned}
            onTogglePin={onTogglePin}
            isDepartmentView={isDepartmentView}
          />,
        ]}
      />
    </Row>
  );
};
